import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';
import '@/App.css';
import LandingPage from '@/pages/LandingPage';
import LoginPage from '@/pages/LoginPage';
import RegisterPage from '@/pages/RegisterPage';
import ScorePage from '@/pages/ScorePage';
import MagicPage from '@/pages/MagicPage';
import PaymentSuccessPage from '@/pages/PaymentSuccessPage';
import UserDashboard from '@/pages/UserDashboard';
import AdminDashboard from '@/pages/AdminDashboard';
import DossierDetailPage from '@/pages/DossierDetailPage';
import BlogPage from '@/pages/BlogPage';
import ArticlePage from '@/pages/ArticlePage';
import LegalNoticesPage from '@/pages/LegalNoticesPage';
import PrivacyPolicyPage from '@/pages/PrivacyPolicyPage';
import LawyerDashboard from '@/pages/LawyerDashboard';
import ConsentConfirmPage from '@/pages/ConsentConfirmPage';
import AboutPage from '@/pages/AboutPage';
import FaqPage from '@/pages/FaqPage';
import NotFoundPage from '@/pages/NotFoundPage';
import { Toaster } from '@/components/ui/sonner';
import ConsentBanner from '@/components/ConsentBanner';

function App() {
  return (
    <HelmetProvider>
      <div className="App">
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<LandingPage />} />
            <Route path="/login" element={<LoginPage />} />
            <Route path="/register" element={<RegisterPage />} />
            <Route path="/score/:dossierId" element={<ScorePage />} />
            <Route path="/magic" element={<MagicPage />} />
            <Route path="/payment-success" element={<PaymentSuccessPage />} />
            <Route path="/dashboard" element={<UserDashboard />} />
            <Route path="/dossier/:dossierId" element={<DossierDetailPage />} />
            <Route path="/admin" element={<AdminDashboard />} />
            <Route path="/lawyer" element={<LawyerDashboard />} />
            <Route path="/blog" element={<BlogPage />} />
            <Route path="/blog/:slug" element={<ArticlePage />} />
            <Route path="/mentions-legales" element={<LegalNoticesPage />} />
            <Route path="/confidentialite" element={<PrivacyPolicyPage />} />
            <Route path="/consent/confirm/:token" element={<ConsentConfirmPage />} />
            <Route path="/a-propos" element={<AboutPage />} />
            <Route path="/questions-frequentes" element={<FaqPage />} />
            {/* URL inconnue : vraie page 404 en noindex.
                Ne JAMAIS remettre de <Navigate to="/" /> ici : une redirection
                systématique empêche Google de traiter l'URL comme une 404 et la
                laisse indéfiniment en « Page avec redirection » dans la Search Console. */}
            <Route path="*" element={<NotFoundPage />} />
          </Routes>
        </BrowserRouter>
        <Toaster position="top-right" />
        <ConsentBanner />
      </div>
    </HelmetProvider>
  );
}

export default App;